import { gql } from '@apollo/client'

export const M_LOGIN = gql`
  mutation TokenAuth($username: String!, $password: String!) {
    tokenAuth(username: $username, password: $password) {
      payload
      refreshExpiresIn
      refreshToken
      token
    }
  }
`
export const M_UPLOAD = gql`
  mutation UploadMutation($name: String!, $file: Upload!) {
    upload(logoFile: $file, name: $name) {
      manufacturer {
        id
        name
        logo
      }
    }
  }
`
export const MC_MANUFACTURER = gql`
  mutation VehicleMftCreate(
    $code: String!
    $details: String!
    $logo: Upload!
    $name: String!
  ) {
    createVehicleManufacturer(
      code: $code
      details: $details
      logo: $logo
      name: $name
    ) {
      manufacturer {
        id
        name
        code
      }
    }
  }
`
export const MU_MANUFACTURER = gql`
  mutation EditVehicleMft(
    $code: String
    $delete: Boolean
    $details: String
    $id: Int!
    $logo: Upload
    $name: String
  ) {
    editVehicleManufacturer(
      code: $code
      delete: $delete
      details: $details
      id: $id
      logo: $logo
      name: $name
    ) {
      manufacturer {
        id
      }
    }
  }
`

export const MC_ENV = gql`
  mutation CreateEnv(
    # $exterior: Boolean
    $name: String!
    # $natural: Boolean
    $env: Upload!
  ) {
    cEnvironment(
      # exterior: $exterior
      name: $name
      # natural: $natural
      senv: $env
    ) {
      environment {
        id
      }
    }
  }
`
export const MU_ENV = gql`
  mutation UpdateEnv(
    # $exterior: Boolean
    $name: String!
    # $natural: Boolean
    $env: Upload!
  ) {
    uEnvironment(
      # exterior: $exterior
      name: $name
      # natural: $natural
      senv: $env
    ) {
      environment {
        id
      }
    }
  }
`
export const MD_ENV = gql`
  mutation DeleteEnv($id: Int!) {
    dEnvironment(id: $id) {
      success
    }
  }
`
export const MC_VTY = gql`
  mutation VehicleTypeCreate(
    $icon: Upload!
    $iconDetails: String!
    $vehicleType: String!
  ) {
    cVehicleType(
      icon: $icon
      iconDetails: $iconDetails
      vehicleType: $vehicleType
    ) {
      vehicleType {
        id
        vehicleType
      }
    }
  }
`

export const MU_VTY = gql`
  mutation VehicleTypeCreate(
    $icon: Upload
    $iconDetails: String
    $vehicleType: String
    $id: Int!
  ) {
    uVehicleType(
      icon: $icon
      iconDetails: $iconDetails
      vehicleType: $vehicleType
      id: $id
    ) {
      vehicleType {
        id
      }
    }
  }
`

export const MC_VEHICLE = gql`
  mutation CreateVehicle(
    $vMnContent: Boolean!
    $vMnId: Int
    $vMnLogo: Upload
    $vMnName: String
    $vMnCode: String
    $vMnDetail: String
    $vMdContent: Boolean!
    $vMdId: Int
    $vMdTypeId: Int!
    $vMdName: String
    $vMdImage: Upload
    $vMdCountry: String
    $vMdCode: String
    $vMdImAltText: String
    $vvrIntColor: [Int]
    $vvrBdyColor: [Int]
    $sdmzFile: Upload!
  ) {
    cVehicle(
      mftExists: $vMnContent
      mftId: $vMnId
      mftLogo: $vMnLogo
      mftName: $vMnName
      mftCode: $vMnCode
      mftDetail: $vMnDetail

      vehicleTypeId: $vMdTypeId

      modelExists: $vMdContent
      modelId: $vMdId
      modelName: $vMdName
      modelImage: $vMdImage
      modelCountry: $vMdCountry
      modelCode: $vMdCode
      modelImAltText: $vMdImAltText

      vvrIntColor: $vvrIntColor
      vvrBdyColor: $vvrBdyColor

      sdmzFile: $sdmzFile
    ) {
      success
    }
  }
`

export const MD_VEHICLETYPE = gql`
  mutation DeleteVType($id: Int!) {
    dVehicleType(id: $id) {
      success
    }
  }
`
export const MC_HEX_COLOR = gql`
  mutation CreateHexColor($name: String!, $hex: String!) {
    cHexColor(name: $name, hex: $hex) {
      hexColor {
        id
        name
      }
    }
  }
`

export const MD_HEX_COLOR = gql`
  mutation DeleteHexColor($id: Int!) {
    dHexColor(id: $id) {
      success
    }
  }
`
export const MU_HEX_COLOR = gql`
  mutation UpdateHexColor($hex: String, $id: Int!, $name: String) {
    uHexColor(hex: $hex, id: $id, name: $name) {
      hexColor {
        id
      }
    }
  }
`

export const MC_VEHICLE_MAKE = gql`
  mutation CreateVehicleMake(
    $modelId: Int!
    $modelYear: Int!
    $sdmzFile: Upload!
    $vvrBdyColor: [Int]
    $vvrIntColor: [Int]
    $vvrName: String!
  ) {
    cVMake(
      modelId: $modelId
      modelYear: $modelYear
      sdmzFile: $sdmzFile
      vvrBdyColor: $vvrBdyColor
      vvrIntColor: $vvrIntColor
      vvrName: $vvrName
    ) {
      success
    }
  }
`
export const MC_VEHICLE_VARIATION = gql`
  mutation CreateVehicleVariant(
    $makeId: Int!
    $sdmzFile: Upload!
    $vvrBdyColor: [Int]
    $vvrIntColor: [Int]
    $vvrName: String!
  ) {
    cVVariant(
      makeId: $makeId
      sdmzFile: $sdmzFile
      vvrBdyColor: $vvrBdyColor
      vvrIntColor: $vvrIntColor
      vvrName: $vvrName
    ) {
      success
    }
  }
`
export const MC_VARIANT_MODEL = gql`
  mutation AddNewModelToVariant($sdmzFile: Upload!, $vvrId: Int!) {
    cVVrSdm(sdmzFile: $sdmzFile, vvrId: $vvrId) {
      success
    }
  }
`

//material

export const MC_MATERIAL_TYPE = gql`
  mutation createMaterialType(
    $name: String!
    $detail: String!
    $previews: [Upload]
    $roughness: Float!
    $metalness: Float!
    $normalMap: Upload
    $albedoMap: Upload
    $roughnessMap: Upload
    $normalStrength: Float!
    $normalSizeU: Float!
    $normalSizeV: Float!
  ) {
    cMaterialType(
      name: $name
      detail: $detail
      previews: $previews
      roughness: $roughness
      metalness: $metalness
      normalMap: $normalMap
      albedoMap: $albedoMap
      roughnessMap: $roughnessMap
      normalStrength: $normalStrength
      normalSizeU: $normalSizeU
      normalSizeV: $normalSizeV
    ) {
      materialType {
        name
        code
        detail
        roughness
        metalness
        normalMap
        albedoMap
        roughnessMap
        normalStrength
        normalSizeU
        normalSizeV
      }
    }
  }
`
export const MC_MATERIAL_CATALOGUE = gql`
  mutation createMaterialType(
    $name: String!
    $codeStore: String!
    $logo: Upload!
  ) {
    cMaterialCatalogue(name: $name, codeStore: $codeStore, logo: $logo) {
      materialCatalogue {
        name
        id
        logo
      }
    }
  }
`
export const MC_MATERIAL_SWATCH = gql`
  mutation createMaterialSwatch(
    $a1: Float!
    $a2: Float!
    $a3: Float!
    $b1: Float!
    $b2: Float!
    $b3: Float!
    $c1: Float!
    $c2: Float!
    $c3: Float!
    $catId: Int!
    $code: String!
    $albedoMap: Upload
    $detail: String!
    $h1: Float!
    $h2: Float!
    $h3: Float!
    $highlight: Boolean
    $l1: Float!
    $l2: Float!
    $l3: Float!
    $metalness: Float
    $name: String!
    $normalMap: Upload
    $normalSizeU: Float
    $normalSizeV: Float
    $normalStrength: Float
    $order: Int!
    $previews: [Upload]
    $roughness: Float
    $roughnessMap: Upload
    $typeId: Int!
  ) {
    cMaterialSwatch(
      a1: $a1
      a2: $a2
      a3: $a3
      b1: $b1
      b2: $b2
      b3: $b3
      c1: $c1
      c2: $c2
      c3: $c3
      catId: $catId
      codeStore: $code
      albedoMap: $albedoMap
      detail: $detail
      h1: $h1
      h2: $h2
      h3: $h3
      highlight: $highlight
      l1: $l1
      l2: $l2
      l3: $l3
      metalness: $metalness
      name: $name
      normalMap: $normalMap
      normalSizeU: $normalSizeU
      normalSizeV: $normalSizeV
      normalStrength: $normalStrength
      order: $order
      previews: $previews
      roughness: $roughness
      roughnessMap: $roughnessMap
      typeId: $typeId
    ) {
      materialSwatch {
        name
        id
        detail
      }
    }
  }
`
